import {
  footerBaseStyle,
  TFooterTheme,
} from '../../base/customComponents/footer';
import { TStyleConfig } from '../../base/types';

export const Footer: TStyleConfig<TFooterTheme> = {
  baseStyle: {
    ...footerBaseStyle,
    footer: {
      position: 'relative',
      ...footerBaseStyle.footer,
      mt: ['6', null, null, '3'],
      pt: '0',
      pb: ['0', null, 'unset'],
      bgSize: 'cover',
      bgPos: 'bottom',
      color: 'white',
    },
    stackGap: '0',
    footerBar: {
      display: 'flex',
      flexDir: ['column', null, 'row'],
      h: '70px',
      pr: '0',
      mb: '0',
      borderRadius: 'md',
      alignItems: 'center',
      justifyContent: ['center', null, 'unset'],
    },
    footerLink: {
      color: 'alpha.500',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    footerLinkTel: {
      color: 'alpha.500',
      textTransform: 'lowercase',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    customFooterLink: {
      color: 'alpha.500',
      fontSize: 'sm',
      textTransform: 'capitalize',
      cursor: 'pointer',
      display: 'inline-block',
      mt: '0',
      whiteSpace: 'nowrap',
    },
    weAcceptBox: {
      mb: '4',
    },
    footerLinks: {
      label: 'FooterLinks',
      mt: ['10', null, '0'],
      ml: ['unset', null, 'auto'],
      pb: ['4', null, '0'],
      alignItems: 'center',
      justifyContent: ['space-around', null, 'unset'],
      color: 'white',
      fontWeight: 'medium',
      flexDir: ['row', null, 'unset'],
      display: 'inline-flex',
    },
    footerMobile: {
      label: 'FooterMobile',
      borderRadius: 'md',
      border: '2px solid',
      borderColor: 'white',
      _last: {
        ml: '1.5',
      },
      w: '32',
    },
    footerText: {
      color: 'white',
    },
    ourPartners: {
      display: 'flex',
      justifyContent: ['center', null, 'inherit'],
      label: 'OurPartners',
      color: 'alpha.500',
      textTransform: 'uppercase',
      fontSize: ['xs', null, '14px'],
      pb: '1',
    },
    weAccept: {
      display: 'flex',
      justifyContent: ['center', null, 'inherit'],
      color: 'alpha.500',
      textTransform: 'uppercase',
      fontSize: ['xs', null, '14px'],
      pb: '1',
    },
    footerContentContainer: {
      px: ['2.5', null, 'unset'],
      gap: '0',
      ...footerBaseStyle.footerContentContainer,
      bg: [null, null, 'transparent'],
      justifyContent: 'space-between',
      mb: '2',
      '&': {
        flexDirection: ['column', null, 'column-reverse'],
      },
    },
    imageWrapper: {
      label: 'ImageWrapper',
      mr: '0',
      justifyContent: 'center',
    },
    partnerWrapper: {
      mr: '0',
    },
    partnerImages: {
      label: 'PartnerImages',
    },
    quickLinks: {
      color: 'alpha.500',
      textTransform: 'uppercase',
      fontSize: ['xs', null, '14px'],
      display: 'flex',
      justifyContent: ['center', null, 'inherit'],
      mt: '2',
    },
    nav: {
      ...footerBaseStyle.nav,
      fontSize: 'sm',
      fontWeight: 'medium',
      minW: [null, null, '370px'],
      mt: 'unset',
      display: ['flex', null, 'grid'],
      flexDir: 'column',
      gridTemplateColumns: '1fr 1fr 1fr',
      gridTemplateRows: 'auto',
      columnGap: '28',
      rowGap: ['0', null, '2'],
      alignItems: ['center', null, 'end'],
      gridTemplateAreas: `
        ". ."
      `,

      '> a': {
        color: 'inherit',
      },
    },
    blurb: {
      ...footerBaseStyle.blurb,
      flex: 'unset',
      textAlign: ['center', null, 'left'],
      color: 'alpha.200',
      width: 'unset',
      mb: '0',
      ml: [null, '0'],
      mr: [null, null, '0'],
    },
    blurbHeading: {
      color: 'white',
      ml: 'unset',
      mt: '2',
    },
    blurbHeadingAge: {
      ...footerBaseStyle.blurbHeadingAge,
      borderColor: 'blackAlpha.50',
      color: 'white',
      border: '3px solid',
      mb: '2',
      boxSize: '8',
      fontSize: 'xs',
    },
    blurbHeadingThink: {
      fontSize: 'xs',
      fontWeight: 'bold',
      mb: '4',
    },
    blurbContent: {
      ...footerBaseStyle.blurbContent,
      ml: 'unset',
      mr: [null, null, 'auto'],
    },
    copyright: {
      ...footerBaseStyle.copyright,
      color: 'white',
      textAlign: ['center', null, 'left'],
      mt: '7',
      px: ['8', 'unset'],
      py: '0',
      fontWeight: ['semibold', 'medium'],
    },
    container: {
      '&&': {
        px: '0',
      },
    },
    emailUs: {
      px: ['16', null, '0'],
      fontSize: ['sm', null, 'md'],
      fontWeight: 'bold',
      textAlign: ['center', null, 'left'],
    },
  },
  sizes: {},
  variants: {},
};
